<template>
  <div class="number">
    {{ value }}
  </div>
</template>
<script>
export default {
  props: {
    value: Number,
    config: Object,
    index: Number
  }
}
</script>
   